import AiSettingsForm from './AiSettingsForm';

export default AiSettingsForm;
